import { Assessment } from "../../../../models";
import { ListResponse } from "../../../../lib/util/data/list/ListResponse";
import { REFETCH_POLLING_TIMES_MS } from "../../PropertyDashboard";
import { graphQLAssessmentDAO } from "../../../../lib/assessment/GraphQLAssessmentDAO";
import { useQuery } from "react-query";

export const useAssessmentsByPropertyId = (propertyId: string) => {
    return useQuery({
        queryKey: ['assessments', 'property', propertyId],
        queryFn: async () => {
            let allAssessments: Array<Assessment> = [];
            let nextToken = undefined;
            do {
                const assessments: ListResponse<Assessment> = await graphQLAssessmentDAO.listAssessmentsByProperty(propertyId, nextToken);
                allAssessments = [...allAssessments, ...assessments.items];
                nextToken = assessments.nextToken;
            } while (nextToken);
            return allAssessments;
        },
        enabled: !!propertyId,
        refetchInterval: REFETCH_POLLING_TIMES_MS,
        refetchIntervalInBackground: true,
        keepPreviousData: true
    });
};